import * as React from "react";
import { Tab, Tabs, Box, Typography } from "@mui/material";

interface Props {
  TabNames: string[];
  TabContent: React.ReactNode[];
  onChange?: () => void;
}

function CustomTabPanel({
  children,
  index,
}: {
  children: React.ReactNode;
  index: number;
}) {
  return (
    <Box
      role="tabpanel"
      id={`tabpanel-${index}`}
      sx={(theme) => ({
        backgroundColor: theme.palette.secondary.main,
        border: `1px solid ${theme.palette.secondary.dark}`,
        borderRadius: 0,
        borderTopLeftRadius: 0,
        marginTop: "-2px",
        padding: theme.spacing(2),
      })}
    >
      <Typography>{children}</Typography>
    </Box>
  );
}

export default function BasicTabs({ TabNames, TabContent, onChange }: Props) {
  const [tab, setTab] = React.useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
    onChange?.();
  };

  const tabList = TabNames.map((name: string, index: number) => (
    <Tab
      key={index}
      sx={(theme) => ({
        "width": `${100 / TabNames.length}%`,
        "maxWidth": index !== TabNames.length - 1 ? "49.4%" : "50%",
        "marginRight": index !== TabNames.length - 1 ? "6px" : 0,
        "height": 32,
        "minHeight": 32,
        "backgroundColor": theme.palette.secondary.main,
        "border": `1px solid ${theme.palette.secondary.dark}`,
        "borderBottomColor": theme.palette.secondary.main,
        "borderTopLeftRadius": 5,
        "borderTopRightRadius": 5,
        "zIndex": 1,
        '&[aria-selected="false"]': {
          backgroundColor: "#e8ecf3",
        },
      })}
      label={name}
    />
  ));

  const tabContent = TabContent.map((content, index) =>
    tab === index ? (
      <CustomTabPanel key={index} index={index}>
        {content}
      </CustomTabPanel>
    ) : null,
  );

  return (
    <Box
      sx={{
        "marginBottom": "1rem",
        "& .MuiTabs-root, & .MuiTabs-flexContainer": {
          maxHeight: 32,
          minHeight: 32,
        },
      }}
    >
      <Box>
        <Tabs value={tab} onChange={handleTabChange} aria-label="basic-tabs">
          {tabList}
        </Tabs>
      </Box>
      {tabContent}
    </Box>
  );
}
